import { canonicalizeKey } from "./keys";
import { evaluateRbac } from "./rbacEngine";
import type { AccessQuery, PermissionMap } from "./types";

export const GLOBAL_ENTITY = "*";

/**
 * Permissions for pages that have migrated to UI-config, normalized into the
 * canonical PermissionMap shape (page/action keys pre-canonicalized via
 * canonicalizeKey — see dashboardInfoProvider.ts). Fed after login/tab-fetch
 * from the ui-permissions / fetch-uiconfig response.
 */
let uiPermissions: PermissionMap | null = null;

export function setUiConfigPermissions(
  permissions: PermissionMap | null
): void {
  uiPermissions = permissions;
}

/** A page is "covered" when the UI-config response owns its permissions. */
export function isPageCoveredByUiConfig(page: string): boolean {
  return (
    uiPermissions !== null &&
    Object.hasOwn(uiPermissions, canonicalizeKey(page))
  );
}

export function evaluateUiConfig(query: AccessQuery): boolean {
  const page = canonicalizeKey(query.page);
  if (!isPageCoveredByUiConfig(page)) return true;
  return evaluateRbac(
    {
      ...query,
      page,
      entityIds: GLOBAL_ENTITY,
      actions: query.actions?.map(canonicalizeKey)
    },
    uiPermissions
  );
}
